import { format } from 'date-fns'
import { useState } from 'react'
import { toast } from 'react-toastify'

import { useDownloadTrainingDataMutation } from '../../app/apiSliceConfigStudioApi'
import { InlineLoader } from '../../common/components'
import { Button, InputCalendar, Modal, Text } from '../../common/designs'
import { GLOBAL_DATE_FORMAT } from '../../common/types/datetime'
import { downloadFile } from '../../common/utils/utils'
import type { TrainingDataCsvDownloadParams } from './types'

interface Props {
  isOpen: boolean
  appName: string
  onClose: () => void
}

const TrainingDataCsvDownloadModal = ({ isOpen, appName, onClose }: Props) => {
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [downloadTrainingData, { isLoading }] = useDownloadTrainingDataMutation()

  const onDownloadTrainingData = async () => {
    toast.info(`Started training data loading`)
    const params: TrainingDataCsvDownloadParams = {
      application_name: appName,
    }

    if (startDate) {
      params.start_date = format(startDate, GLOBAL_DATE_FORMAT)
    }

    const trainingCsv = await downloadTrainingData(params).unwrap()
    downloadFile(window.URL.createObjectURL(new Blob([trainingCsv])), `${appName}.csv`)
  }

  return (
    <Modal label='Download Training Data csv' size='2xl' open={isOpen} onClose={onClose}>
      {isLoading ? (
        <InlineLoader />
      ) : (
        <div>
          <div className='mb-4 flex flex-col gap-2'>
            <Text>[Optional] Only fetch data starting from:</Text>
            <InputCalendar selected={startDate} onChange={setStartDate} />
          </div>
          <Button onClick={onDownloadTrainingData}>Download Training Data csv</Button>
        </div>
      )}
    </Modal>
  )
}

export default TrainingDataCsvDownloadModal

